import { Component } from '@angular/core';
import { map } from 'rxjs/operators';

import { EntityType } from '@shared/components/audit/models/audit-log';
import { ContactEventService } from '@features/contacts/services/contact-event.service';

@Component({
  selector: 'app-company-audit-list',
  templateUrl: './company-audit-list.component.html'
})
export class CompanyAuditListComponent {
  companyId$ = this.contactEventService.selectedContactInfo$.pipe(
    map(contactInfo => contactInfo.id)
  );
  entityType = EntityType.COMPANY;

  constructor(private contactEventService: ContactEventService) {}
} 